import {
  getPolicyNew
} from '@/api/system/oss'
import { Message } from 'element-ui'
import * as qiniu from 'qiniu-js'







export async function upload(file, path, noToast) {
  const hzs = file.file.name.split('.')
  const hz = file.file.realType || hzs[hzs.length - 1]
  const data = await getPolicyNew(hz)

  // let name = new Date().getTime() + '_' + file.name
  const img = file.file





  // const reader = new FileReader()
  // reader.readAsDataURL(img)
  // reader.onload = function (oFREvent) {
  //   img = oFREvent.target.result
  // }
  const config = {
    useCdnDomain: true
  }

  return new Promise((resolve, reject) => {
    const observer = {
      next(res) {
        // console.log(res, 'next')
      },
      error(err) {
        Message.error('图片服务器繁忙,请重试上传')
        reject(err)
      },
      complete(res) {
        console.log(res)
        const imgUrl = 'https://7niu.ztxin.cn/' + res.key

        try {
          // Message.success('图片上传成功')
          resolve(imgUrl)
        } catch (e) {
          console.log(e.message)
        }


      }
    }

    const putExtra = {


    }
    const observable = qiniu.upload(img, data.data.key, data.data.token, putExtra, config)

    observable.subscribe(observer) // 上传开始
  })



}

// export async function upload(file, path, noToast) {
//   var accessKey = 'KulIImjIzLO-sm-xoHG4jpenB83G39V0O7n8emqM'
//   var secretKey = 'UViZTyimIXd-ygRGIIYLzZcVUXc8zf2hfg-B1cj1'
//   var mac = new qiniu.auth.digest.Mac(accessKey, secretKey)
//   var options = {
//     scope: 'ztxin' // 替换为你自己的存储空间名称
//   }
//   var putPolicy = new qiniu.rs.PutPolicy(options)
//   var uploadToken = putPolicy.uploadToken(mac)

//   // 构造配置对象
//   var config = new qiniu.conf.Config()
//   var qiniuUploader = new qiniu.uploader.UploadManager(config)

//   // 执行上传
//   var key = file.file.name // 使用文件的原始名称作为文件名
//   qiniuUploader.put(file, key, uploadToken, null, null, function (err, respBody, respInfo) {
//     if (err) {
//       console.error(err)
//     } else {
//       console.log(respBody)
//     }
//   })

// }


// 生成上传凭证
// 替换为你自己的七牛云Access Key和Secret Key

















// WEBPACK FOOTER //
// ./src/utils/upload.js